"use client";

import { SORT_OPTIONS } from "@/utils";
import React, { useState } from "react";

interface SortPanelProps {
  onApplySort: (sortOrder: string) => void;
  currentSortOrder: string;
  onClose: () => void;
}


const SortPanel: React.FC<SortPanelProps> = ({
  onApplySort,
  currentSortOrder,
  onClose,
}) => {
  const [selectedSort, setSelectedSort] = useState(currentSortOrder);

  const handleApply = () => {
    onApplySort(selectedSort);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-white z-50 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <button onClick={onClose} className="text-lg">
          ✕
        </button>
        <h2 className="text-lg font-semibold font-raleway">Sort By</h2>
        <div className="w-6"></div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4">
        <div className="space-y-4">
          {SORT_OPTIONS.map((option) => (
            <label
              key={option.value}
              className="flex items-center space-x-3 cursor-pointer py-2"
            >
              <input
                type="radio"
                name="sort"
                value={option.value}
                checked={selectedSort === option.value}
                onChange={(e) => setSelectedSort(e.target.value)}
                className="w-4 h-4 text-black border-gray-300 focus:ring-black"
              />
              <span className="text-base font-raleway">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <button
          onClick={handleApply}
          className="w-full py-3 bg-black text-white font-raleway font-semibold rounded hover:bg-light-grey"
        >
          APPLY SORT BY
        </button>
      </div>
    </div>
  );
};

export default SortPanel;
